export const UPDATE_CEP_COUNTS_GET_SITES = 'UPDATE_CEP_COUNTS_GET_SITES';
export const UPDATE_CEP_COUNTS_LOADING = 'UPDATE_CEP_COUNTS_LOADING';
export const UPDATE_CEP_COUNTS_ERRORS = 'UPDATE_CEP_COUNTS_ERRORS';
export const UPDATE_CEP_COUNTS_UPDATE_SUCCESS =
  'UPDATE_CEP_COUNTS_UPDATE_SUCCESS';
export const UPDATE_CEP_COUNTS_CLEAR_ERRORS = 'UPDATE_CEP_COUNTS_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/state/update/types.js